import Logo from "../assets/Logo.png";
import "./Login.css";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link as host } from "../host/host";
import { signin } from "../actions/Auth";
import Input from "./input";
import React from "react";
import axios from "axios";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { isEmail } from "validator";
import { Typography } from "@mui/material";
import { useState } from "react";
import { Paper, Button } from "@mui/material";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";
import RSS from "../assets/rosoftsavvy.png";

const Login = () => {
  // return <div className="box"  />

  const initialState = {
    email: "",
    password: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleOnSubmit = (e) => {
    e.preventDefault();
    dispatch(signin(formData, navigate));
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleShowPassword = () =>
    setShowPassword((prevShowPassword) => !prevShowPassword);

  const { email } = formData;
  const [isUserValid, setIsUserValid] = React.useState(false);
  React.useEffect(() => {
    if (isEmail(email)) {
      const fetchUser = async () => {
        let fetchingId;
        try {
          fetchingId = toast.loading("Validating your eligibility....");
          const res = await axios.get(
            `${host}/api/v1/users/user-for-verification/user_trying?email=${email}`
          );
          toast.remove(fetchingId);
          if (res.data[0] && res.data[0].e_advice === "Restricted") {
            setIsUserValid(false);
            toast.error(
              "You can't access this system, please contact your administrator"
            );
          } else {
            setIsUserValid(true);
          }
        } catch (error) {
          toast.remove(fetchingId);
          toast.error(error.message);
        }
      };

      fetchUser();
    }
  }, [email]);

  return (
    <div className='container'>
      <Helmet>
        <title>Login | Portfolio Manager</title>
      </Helmet>
      <Paper elevation={16} className='screen'>
        <div className='screen__content'>
          <form className='login' onSubmit={handleOnSubmit}>
            <LazyLoadImage
              effect='blur'
              width={70}
              height={"auto"}
              src={Logo}
              alt='Nyankomasi-Ahenkuro Rural Bank PLC logo'
            />
            <Typography style={{ fontWeight: "bolder", fontSize: "12px" }}>
              NARB eAdvice
            </Typography>
            <Typography
              style={{
                marginTop: "10px",
                fontWeight: "bold",
                fontSize: "12px",
              }}>
              Account Login
            </Typography>
            <div className='login__field'>
              <Input
                name='email'
                label={"Email Address"}
                handleChange={handleChange}
                type='email'
                placeholder='User name / Email'
              />
            </div>
            <div className='login__field'>
              {isUserValid && (
                <Input
                  name={"password"}
                  label={"Password"}
                  handleChange={handleChange}
                  type={showPassword ? "text" : "password"}
                  handleShowPassword={handleShowPassword}
                />
              )}
            </div>
            {isUserValid && (
              <Button
                variant='contained'
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
                type='submit'>
                <span className='button__text'>Continue </span>
              </Button>
            )}
          </form>
        </div>

        <div className='screen__background'>
          <span className='screen__background__shape screen__background__shape4'></span>
          <span className='screen__background__shape screen__background__shape3'></span>
          <span className='screen__background__shape screen__background__shape2'></span>
          <span className='screen__background__shape screen__background__shape1'></span>
        </div>
      </Paper>
      <em style={{ marginTop: "10px" }}>
        Powered By <img src={RSS} alt='rss logo' width={30} height={"auto"} />
      </em>
    </div>
  );
};

export default Login;
